<template>
  <div class="c-avatar" :class="sizeAvatar">
    <img v-if="exibirImagem" :src="imageUrl" class="c-avatar-img" @error="errorImage()" />
    <div
      v-else
      :class="sizeAvatar"
      class="c-avatar c-avatar-img default-img text-center text-white bg-gray-500"
      :style="{ 'font-size': sizeFontAvatar }"
    >
      {{ nameLetters }}
    </div>
  </div>
</template>

<script>
import axiosInstance from '@/utils/axiosInstance.js'

export default {
  props: {
    size: {
      type: String,
      return: () => 'sm',
    },
    sizeFontAvatar: {
      type: String,
      return: () => '50px',
    },
  },
  data() {
    return {
      exibirImagem: true,
    }
  },
  computed: {
    imageUrl: function() {
      return `${axiosInstance.defaults.baseURL}user/api/v1.0/user/profile/${this.$store.state.auth.user.id}/image/small?v=${this.$store.state.auth.avatarVersion}`
      // return this.$store.state.auth.userAvatar
    },
    nameLetters: function() {
      if (this.$store.state.auth.user.name) {
        var array = this.$store.state.auth.user.name && this.$store.state.auth.user.name.split(' ')
        if (array.length > 1) {
          return array[0].substring(0, 1).toUpperCase() + (array.length >= 2 ? array[array.length - 1].substring(0, 1).toUpperCase() : '')
        } else {
          return array[0].substring(0, 1).toUpperCase()
        }
      }
    },
    sizeAvatar() {
      return `c-avatar-${this.size}`
    },
  },
  methods: {
    errorImage() {
      this.exibirImagem = false
    },
  },
}
</script>

<style></style>
